<template>
  <div class="pulse-button-container">
    <button
      class="pulse-button"
      @click="showHomeScreen(true)"
      v-bind:style="buttonStyles"
    >
      <i class="fas fa-caret-left"></i>
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";

export default {
  name: "add-homescreen-button",
  computed: {
    ...mapState({
      customization: (state) => state.common.customization,
      industryId: (state) => state.common.industryId,
    }),
    buttonStyles: function() {
      var borderColor = this.customization.mainColor;
      var colorStyle = this.customization.mainColor;
      return {
        'border-color': borderColor,
        color: colorStyle,
        "--shadow-color": borderColor,
      };
    },
  },
  methods: {
    ...mapActions({
      showHomeScreen: "standalone/showAddHomeScreen",
    }),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.pulse-button-container {
  position: absolute;
  right: 0;
  top: 25%;
  z-index: 0;
}

.pulse-button {
  position: relative;
  width: 50px;
  height: 50px;
  aspect-ratio: 1;
  font-size: 1.3em;
  border-style: solid;
  border-width: 3px;
  border-radius: 50%;
  background: rgba(90, 153, 212, 0.2);
  cursor: pointer;
  z-index: 0;
  display: grid;
  align-items: center;
  transform: translateX(50%);
    animation: breath 1.5s ease-in infinite 1s;

  &::before {
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-color: var(--shadow-color);
    z-index: -1;
    transform: scale(1);
    opacity: 0;
    animation: pulse 1.5s infinite;
  }

  i {
    position: absolute;
    left: 10px;
  }
}

.pulse-button:hover {
  &::before {
    -webkit-animation: none;
    animation: none;
  }
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }
  70% {
    transform: scale(2.5);
    opacity: 0;
  }
  100% {
    transform: scale(0.9);
    opacity: 0;
  }
}

@keyframes breath{
  0% {
    transform: translateX(50%) scale(0.9);
  }
  70% {
    
    transform: translateX(50%) scale(1);
  }
  100% {
    transform: translateX(50%) scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// add-homescreen-button.vue?5548754c